import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../../language/keys';
import { ProgressBar } from '../../ProgressBar';
import { style } from './style';

type RunStatusCanceledProps = {
  title: string,
}

export const RunStatusCanceled = ({
  title,
}:RunStatusCanceledProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box>
      <ProgressBar
        value={ 100 }
        color="#C4C7CC"
      />
      <Box sx={ style.box.sx }>
        <Typography variant="overline" sx={ style.typograpyStatus.sx }>
          {title} -
        </Typography>
        <Typography variant="overline" sx={ style.typograpyDesc.sx }>
          {translate(STRING_KEYS.CANCELED)}
        </Typography>
      </Box>
    </Box>
  );
};
